/** Matches communications MessageController.TWILIO_PRIMARY_START_COMMUNICATION_KEYWORD */
export const PRIMARY_START_SMS_KEYWORD = "START";
